/**
 * Keyboard focus management for the drawer and dialogs (QM-NX-016 keyboard trap, WCAG 2.1.2 / 2.4.3).
 * Tab cycles inside an open dialog, Escape always closes it and focus returns to the opener. A trap that
 * cannot be escaped with Escape is a release-blocking defect; `canEscape` is asserted in tests.
 */
export const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

export function nextFocusIndex(current: number, count: number, shift: boolean): number {
  if (count <= 0) return -1;
  if (current < 0) return shift ? count - 1 : 0;
  return shift ? (current - 1 + count) % count : (current + 1) % count;
}

export interface KeyLike { key: string; shiftKey: boolean; preventDefault(): void }

/** Returns 'close' for Escape, the index to focus for Tab, or null. */
export function dialogKeydown(e: KeyLike, current: number, count: number): 'close' | number | null {
  if (e.key === 'Escape') return 'close';
  if (e.key !== 'Tab') return null;
  e.preventDefault();
  return nextFocusIndex(current, count, e.shiftKey);
}

export const canEscape = (handler: typeof dialogKeydown) => handler({ key: 'Escape', shiftKey: false, preventDefault() {} }, 0, 3) === 'close';
